<template>
	<StandardModal
		open
		:title="category.title"
		:confirmText="$t('common_button_delete')"
		:confirmProps="{ danger: true, loading: isProcessing }"
		@confirm="deleteCategory"
		@cancel="close"
		small
		ref="modal"
	>
		<div class="modal-wrapper">
			<TrashCanIcon halo />
			{{ $t('admin_categories_unassigned_groups_warning') }}
		</div>
	</StandardModal>
</template>

<script>
import { StandardModal } from '@/components/common'
import { TrashCanIcon } from '@/icons'
import { del } from '../common'
import { storage } from '@/helpers/utils'

export default {
	name: 'DeleteCategoryModal',
	components: { StandardModal, TrashCanIcon },
	props: {
		category: Object,
	},
	data() {
		return {
			isProcessing: false,
		}
	},
	emits: ['delete', 'close'],
	methods: {
		async deleteCategory() {
			this.isProcessing = true
			try {
				await del(`/organization/categories/${this.category.id}`)
				storage.set('org_mgmt_changed_categories', true)
				this.$emit('delete')
				this.$alert.success(this.$t('admin_categories_delete_category_success'))
				this.close()
			} catch (e) {
				this.isProcessing = false
				this.$refs.modal.$alert.error(this.$t('common_api_error_save'))
			}
		},
		close() {
			this.title = null
			this.$emit('close')
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.modal-wrapper {
	@include flex-column-center;
	max-width: 300px;
	margin: 24px auto;
	text-align: center;
	.pronto-icon {
		color: var(--red-200);
		font-size: 50px;
		margin-bottom: 24px;
	}
}
</style>
